import { Component } from "react";
import OverlayedButton from "./overlayed-button";

export default class Destructable extends Component {
  render() {
    return <OverlayedButton
      {...this.props}
      icon="minus"
      iconBorderColor="#55000bff"
      iconColor="#55000bff"
      tooltip={this.props.tooltip ?? `remove ${this.props.caption.toLowerCase()} profile`}
    />
  }
}